import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  ListItemText,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { axiosInstanceForLambda } from '../../../library/Axios';
import API_ENDPOINTS from '../../../apiEndpoints';
import moment from 'moment';
import dayjs from 'dayjs';
import {
  checkIfExpired,
  database,
  eWayBillColumns,
  inwardSubTypes,
  isWithinEightHours,
  listEwayHeads,
  listEwaySelect,
  mode,
  outwardSubTypes,
  transTypes,
} from './data';
import DataTable from './DataTable';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { listewaybillv2, listewaybillv2Count } from '../../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import OtherDataTable from './otherDataTable';
import Listing from '../../../components/listing';
import TooltipComp from './toolTipComp';
import { useDispatch, useSelector } from 'react-redux';
import { defaultRowsPerPage } from '../../../utils/common';
import SearchIcon from '@mui/icons-material/Search';
import EWayExtend from '../../../components/modals/ewayExtend';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../../redux/reducers/eInvReducer';
import EInvAuth from '../../PrimeFigma/Modals/EInvAuth';
const ListEwayBill = ({ startTimeStamp, endTimeStamp }) => {
  const [listEwayDataFrom, setListEwayDataFrom] = useState({
    label: 'From Our Database',
    id: 'od',
  });
  const [extendData, setExtendData] = useState({});
  const [ewayDate, setEwayDate] = useState('');
  const [eWaySelect, setEWaySelect] = useState({
    label: 'From Our Database',
    id: 'od',
  });
  const [cancelEOpen, setCancelEOpen] = useState(false);
  const [displayPeriod, setDisplayPeriod] = useState({
    startTimestamp: '',
    endTimestamp: '',
  });
  const [list, setList] = useState([]);
  const [ourList, setOurList] = useState([]);
  const [otherList, setOtherList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const DateRangeRef = useRef(null);
  const [dataCount, setDataCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const eWayCheckBool = localStorage.getItem('ewayCheck');
  const [debo, setDebo] = useState({});
  const [extendModalOpen, setExtendModalOpen] = useState(false);
  const [maxAmounts, setMaxAmounts] = useState({
    totalitemamount: null,
    gstamount: null,
    totalinvoiceamount: null,
  });
  const test = JSON.parse(localStorage.getItem('singleOthewayData'));
  const listEwayData = JSON.parse(localStorage.getItem('ewayListData')) || '';
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  // const { startTimeStamp, endTimeStamp } = dashboardData?.report;
  useEffect(() => {
    if (eWayCheckBool == 'true' && test) {
      setListEwayDataFrom(test.listEwayDataFrom);
      setEwayDate(test.ewayDate);
      setEWaySelect(test.eWaySelect);
      if (test.eWaySelect.id === 'mewb') {
        setList(listEwayData);
      } else {
        setOtherList(listEwayData);
      }
    } else {
      setTimeout(() => {
        localStorage.removeItem('ewayCheck');
        localStorage.removeItem('singleOthewayData');
      }, 1000);
    }

    return () => {
      localStorage.removeItem('ewayCheck');
    };
  }, []);
  useEffect(() => {
    if (listEwayDataFrom?.id === 'od') {
      setEWaySelect({
        label: 'My Eway bills',
        id: 'mewb',
      });
      listEway({ ordertype: 'desc' });
    } else {
      setOurList([]);
    }
  }, [listEwayDataFrom?.id]);
  function convertToUnix(dateStr) {
    // Input: "dd-mm-yyyy"
    const [day, month, year] = dateStr.split('-');

    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    const combinedDate = new Date(
      `${year}-${month}-${day}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    );

    // Unix timestamp in seconds
    return Math.floor(combinedDate.getTime() / 1000);
  }
  const dispatch = useDispatch();
  let prevData = useSelector((state) => state.eInvReducer.data);
  console.log(prevData, 'prevData');
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  //  let prevData = useSelector((state) => state.eInvReducer.data);

  const listEway = async ({ ordertype = 'asc' }) => {
    localStorage.removeItem('ewayListData');
    setList([]);
    setDebo({});
    setOurList([]);
    setOtherList([]);
    setBackdropOpen(true);
    setPage(0);

    try {
      if (listEwayDataFrom?.id !== 'od') {
        if (ewayDate) {
          if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect != 1) {
            setCancelEOpen(true);
          } else {
            const payload = {
              action: eWaySelect.id === 'mewb' ? 'GET_EWAY_BILL_ASSIGNED_TO_YOU_BY_DATE' : 'GET_EWAY_BILL_GENERATED_ON_YOU',

              data: {
                Gen_gstin: '07AGAPA5363L002',
                date: moment(ewayDate).format('DD/MM/YYYY'),
                extraDetails: 'Y',
              },
            };
            try {
              const res = await axiosInstanceForLambda.post(`${API_ENDPOINTS.REACT_APP_EWAYBILL_URL}`, payload);

              localStorage.setItem('ewayListData', JSON.stringify(res.data.data));
              if (res.data.status === 'success' && eWaySelect.id === 'mewb') {
                setList(res.data.data);
              } else {
                setOtherList(res.data.data);
              }
            } catch (err) {
              const message = err?.response?.data?.details[0]?.errorDesc;
              if (message) {
                showWarningSnackbar(message);
              } else {
                showWarningSnackbar('Something went wrong');
              }
              console.log(err, 'lololoooooo');
            }
          }
        } else {
          showWarningSnackbar('Please provide date');
        }
      } else {
        let resActive = await API.graphql(
          graphqlOperation(listewaybillv2, {
            rowfrom: 0,
            limitno: Math.abs(rowsPerPage * 1),
            columnname: 'ewaybilldate',
            startdate: startTimeStamp,
            enddate: endTimeStamp,
            ordertype,
            searchmode: 0,
            searcharray: '[]',
          })
        );
        let count = await API.graphql(
          graphqlOperation(listewaybillv2Count, {
            columnname: 'ewaybilldate',
            startdate: startTimeStamp,
            enddate: endTimeStamp,
            ordertype,
            searchmode: 0,
            searcharray: '[]',
          })
        );
        setDataCount(count.data.listewaybillv2Count[0].ewaybillcount);
        setOurList(resActive.data.listewaybillv2);
        setMaxAmounts({
          totalitemamount: count.data.listewaybillv2Count[0].maxtotalitemamount,
          gstamount: count.data.listewaybillv2Count[0].maxgstcess,
          totalinvoiceamount: count.data.listewaybillv2Count[0].maxtotalinvoiceamount,
          distance: count.data.listewaybillv2Count[0].maxdistance,
          total_items_count: count.data.listewaybillv2Count[0].maxtotalitemscount,
        });
        setBackdropOpen(false);
      }
    } catch (err) {
      console.log(err, 'err');
      showWarningSnackbar(err?.response?.data?.details?.[0].errorDesc || err?.response?.data?.details);
    } finally {
      setBackdropOpen(false);
      dispatch(einvAuthData({}));
      dispatch(einvAuth(false));
      dispatch(einvPreview({ preview: false, id: 0 }));
      dispatch(einvId(false));
    }
  };
  useEffect(() => {
    listEway({ ordertype: 'desc' });
  }, [startTimeStamp, endTimeStamp]);
  function filterValidValues(data) {
    const isValidValue = (value) => {
      if (value === null || value === undefined || value === '') return false;
      if (typeof value === 'object' && !Array.isArray(value)) {
        const keys = Object.keys(value);
        // Check if the object has keys and at least one non-empty value
        return keys.length > 0 && keys.some((key) => value[key] !== '');
      }
      return true;
    };

    return Object.fromEntries(Object.entries(data).filter(([key, value]) => isValidValue(value)));
  }
  const processObject = (obj) => {
    const result = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if the value is an object (not null or array)
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);

          // Proceed only if the object has more than one key
          if (keys.length > 1) {
            const secondKey = keys[1];

            // Case 1: If the second field's key is "value", update the parent field
            if (secondKey === 'value') {
              obj[key] = value[secondKey];
            }
            // Case 2: If the second field's key is "to"
            else if (secondKey === 'to' || secondKey === 'max') {
              const fromValue = value['from'];
              const toValue = value['to'];
              const minValue = value['min'];
              const maxValue = value['max'];
              // Check if both "from" and "to" fields are present (including empty strings)
              if (fromValue && toValue) {
                // Update only if both are present, even if empty
                obj[key] = { [`${key}from`]: fromValue, [`${key}to`]: toValue };
              } else if (minValue || maxValue) {
                // Update only if both are present, even if empty
                obj[key] = { [`${key}from`]: minValue, [`${key}to`]: maxValue };
              } else {
                obj[key] = { from: '', to: '' };
              }
            }
          }
        }
      }
    }
    return obj;
  };
  const processObject2 = (obj) => {
    const result = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if the value is an object and not an array or null
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const keys = Object.keys(value);

          // Check if the nested keys end with 'from' or 'to'
          const isFromTo = keys.every((k) => k.endsWith('from') || k.endsWith('to') || k.endsWith('min') || k.endsWith('max'));

          if (isFromTo) {
            // Flatten the object by directly assigning the inner fields to the result
            for (const innerKey in value) {
              if (value.hasOwnProperty(innerKey)) {
                result[innerKey] = value[innerKey];
              }
            }
          } else {
            // Keep the object as it is if it doesn't match the pattern
            result[key] = value;
          }
        } else {
          // Directly copy non-object fields
          result[key] = value;
        }
      }
    }
    return result;
  };

  const removedFalsydeboValues = filterValidValues(debo);
  const changeObj = processObject(removedFalsydeboValues);
  const newObj = processObject2(changeObj);
  const lastObj = filterValidValues(newObj);
  const dropDownFind = (types, value) => {
    const dropDown = types.filter((tt) => tt.value === value)[0]?.label;
    return dropDown;
  };
  return (
    <Box sx={{ marginTop: '15px', marginBottom: '15px' }}>
      {/* <Box sx={{ fontSize: '16px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}></Box> */}
      <Grid container>
        <Grid item xs={4} lg={1.8} sx={{ alignItems: 'center' }}>
          <Typography sx={{ alignItems: 'center', height: '33px', display: 'flex' }} variant="h1">
            Eway Bill Listing
          </Typography>
        </Grid>
        {ourList && ourList?.length > 0 && (
          <Grid item xs={4} lg={1}>
            <Tooltip title="Search" placement="top">
              <Button
                sx={{
                  borderWidth: '3px',
                  borderColor: 'primary.main',
                  borderStyle: 'solid',
                  backgroundColor: showSearch === true && '#f3724a',
                  whiteSpace: 'nowrap',
                  // border: EnableSearch ? "2px solid white" : "1px solid white",
                  boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                  m: { sm: '0 6px', md: '0 10px' },
                  fontWeight: 'bold',
                  // backgroundColor: EnableSearch ? "#f3724a" : "white",
                  // "&:hover": {
                  //   backgroundColor: EnableSearch ? "#f3724a" : "white",
                  //   border: EnableSearch ? "2px solid white" : "1px solid white",
                  // },
                  '&:active': {
                    transform: 'scale(0.92)',
                    boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.4)',
                  },
                  height: '30px',
                  minWidth: '10px',
                  width: '30px',
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowSearch((prev) => !prev);
                }}
              >
                <SearchIcon sx={{ fontSize: 20 }} />
              </Button>
            </Tooltip>
          </Grid>
        )}
        <Grid item xs={4} lg={2}>
          <Autocomplete
            size="small"
            options={database}
            value={listEwayDataFrom}
            onChange={(e, newVal) => {
              setListEwayDataFrom(newVal);
            }}
            disableClearable
            renderInput={(params) => <TextField {...params} />}
            renderOption={(props, option) => (
              <MenuItem
                {...props}
                key={option.id}
                value={option.id}
                // onClick={() => {
                //   if (option.id === "od") {
                //     console.log("kkkk");

                //     setEwayDate("");
                //     listEway({ ordertype: "desc" });
                //   } else {
                //     setDisplayPeriod({
                //       startTimestamp: "",
                //       endTimestamp: "",
                //     });
                //     setEWaySelect({
                //       label: "Others Requested Eway bills",
                //       id: "oewb",
                //     });
                //   }
                // }}
              >
                {option.label}
              </MenuItem>
            )}
          />
          {displayPeriod.startTimestamp && (
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 400,
                color: 'black',
                marginTop: '5px',
              }}
            >{`From ${moment(displayPeriod.startTimestamp).format('DD-MM-YYYY')} to ${moment(displayPeriod.endTimestamp).format(
              'DD-MM-YYYY'
            )}`}</Typography>
          )}
        </Grid>
        {listEwayDataFrom?.id !== 'od' && (
          <Grid item xs={4} lg={2} sx={{ marginLeft: '16px' }}>
            {/* // ? (
            //   <EWayCustomDate
            //     ref={DateRangeRef}
            //     value={[
            //       from ? dayjs.unix(from) : null,
            //       to ? dayjs.unix(to) : null,
            //     ]}
            //     onChange={(e) => {
            //       setFrom(e.from ? e.from : "");
            //       setTo(e.to ? e.to : "");
            //     }}
            //   />
            // ) : ( */}
            <TextField
              value={ewayDate}
              onChange={(e) => {
                const value = e?.target.value;
                setEwayDate(value);
              }}
              type="date"
              id="ewayDate"
              name="ewayDate"
              label="E-Way Bill Date"
              variant="outlined"
              disabled={listEwayDataFrom?.id === 'od'}
              size="small"
              fullWidth
              inputProps={{
                max: moment().subtract(1, 'day').format('YYYY-MM-DD'),
              }}
            />
          </Grid>
        )}

        <Grid item xs={4} lg={2.5} sx={{ marginLeft: '20px' }}>
          <Autocomplete
            size="small"
            options={listEwaySelect}
            value={eWaySelect}
            disabled={listEwayDataFrom?.id === 'od'}
            onChange={(e, newVal) => setEWaySelect(newVal)}
            disableClearable
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>

        <Grid item xs={4} lg={1} sx={{ marginLeft: '20px' }}>
          <Button
            variant="contained"
            disabled={listEwayDataFrom?.id === 'od'}
            onClick={() => listEway({ ordertype: 'desc' })}
            sx={{ padding: '4px 16px' }}
          >
            List Eway
          </Button>
        </Grid>
      </Grid>
      {eWaySelect.id === 'mewb' && (
        <>
          {eWaySelect.id === 'mewb' && listEwayDataFrom.id === 'gp' && (
            <DataTable
              data={list}
              setData={setList}
              setBackdropOpen={setBackdropOpen}
              storage={{ listEwayDataFrom, eWaySelect, ewayDate }}
            />
          )}
          {eWaySelect.id === 'mewb' && listEwayDataFrom.id === 'od' && (
            <Box
              sx={{
                width: '100%',
                // overflow: "hidden",
                // backgroundColor: theme?.palette?.TmId.id.toString().includes("9")
                //   ? "#26282A"
                //   : "#f9f9fe",
                // backgroundColor: "#f9f9fe",
                '.MuiTableCell-root': {
                  padding: '5px',
                },
                // color: theme?.palette?.TmId.id.toString().includes("9")
                //   ? "white"
                //   : "black"
                overflowX: 'scroll',
              }}
            >
              <Listing
                storage={{ listEwayDataFrom, eWaySelect, ewayDate }}
                bodyData={ourList}
                setBodyData={setOurList}
                headData={eWayBillColumns}
                startTimeStamp={startTimeStamp}
                endTimeStamp={endTimeStamp}
                count={dataCount}
                showSearch={showSearch}
                setPage={setPage}
                setDataCount={setDataCount}
                countVariable="ewaybillcount"
                queryCount={listewaybillv2Count}
                queryCountName="listewaybillv2Count"
                rowsPerPage={rowsPerPage}
                page={page}
                query={listewaybillv2}
                maxAmounts={maxAmounts}
                localStorageVar="singleOthewayData"
                queryName="listewaybillv2"
                queryParams="ewaybilldate"
                ordertype="desc"
                debo={debo}
                setDebo={setDebo}
                navigateLink="/editewaybill"
                searchArr={
                  lastObj
                  // hasValidValues(debo)
                  // ?
                  // : [{ ewaybilldatefrom: from }, { ewaybilldateto: to }]
                }
                setRowsPerPage={setRowsPerPage}
                renderCell={({ row, field, value, rowIndex }) => {
                  console.log(field, 'field');

                  switch (field) {
                    case 'sl':
                      return (
                        <Typography variant="p" sx={{ paddingLeft: '15px' }}>
                          {' '}
                          {page * rowsPerPage + rowIndex + 1}
                        </Typography>
                      );

                    case 'ewaybilldate':
                      return <TooltipComp value={dayjs.unix(value).format('DD/MMM/YYYY hh:mm:ss A')} />;
                    case 'invoicedate':
                      return <TooltipComp value={dayjs.unix(value).format('DD/MMM/YYYY hh:mm:ss A')} />;
                    case 'validupto':
                      return <TooltipComp value={value === null ? '' : dayjs.unix(value).format('DD/MMM/YYYY hh:mm:ss A')} />;
                    case 'supplytype':
                      return value === 'O' ? 'Outward' : 'Inward';
                    case 'subtype':
                      const types = row['supplytype'] === 'O' ? outwardSubTypes : inwardSubTypes;
                      return dropDownFind(types, value);
                    case 'billingstate':
                      const billState = row['addresses'].filter((to) => to.objecttype === 'Eway_Billto')?.[0]?.statename || ' ';
                      return billState;
                    case 'billingpincode':
                      const billPincode = row['addresses'].filter((to) => to.objecttype === 'Eway_Billto')?.[0]?.pincode || ' ';
                      return billPincode;
                    case 'transactiontype':
                      return dropDownFind(transTypes, value);

                    case 'modeoftransport':
                      return dropDownFind(mode, value);

                    case 'fromtradename':
                      return <TooltipComp value={value} />;
                    case 'status':
                      const extendBtn = row['status'];
                      return extendBtn === 'Extendable' ? (
                        <Button
                          className="noTableCellBorder"
                          sx={{
                            backgroundColor: '#cf1e1e',
                            padding: '3px',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            '&:hover': {
                              backgroundColor: '#cf1e1e',
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setExtendData({
                              ewbNo: row['ewaybillno'],
                              vehicleNo: row['vehicleno'],
                              fromPlace: 'Bangalore',
                              fromState: 29,
                              fromPincode: 530068,
                            });
                            setExtendModalOpen(true);
                          }}
                        >
                          Extend
                        </Button>
                      ) : (
                        value
                      );
                    case 'gstamount':
                      return value + row['cessamount'] === 0 ? '' : value + row['cessamount'];

                    default:
                      return value;
                  }
                }}
              />
            </Box>
          )}
        </>
      )}
      {eWaySelect.id !== 'mewb' && (
        <OtherDataTable data={otherList} setData={setOtherList} storage={{ listEwayDataFrom, eWaySelect, ewayDate }} />
      )}
      {extendModalOpen === true && (
        <EWayExtend
          extendData={extendData}
          setData={setOurList}
          open={extendModalOpen}
          setOpen={setExtendModalOpen}
          title="Provide details to Extend"
          // setBackdropOpen={setBackdropOpen}
        />
      )}
      {/* <CustomDateModal
        open={isCustomDateModalOpen}
        setOpen={setIsCustomDateModalOpen}
        title="From Our Database"
        onSave={(start, end) => {
          const startTimestamp = moment(start, "YYYY-MM-DD");

          const endTimestamp = moment(end, "YYYY-MM-DD");
          setDisplayPeriod({ startTimestamp, endTimestamp });
          console.log(startTimestamp, endTimestamp, "kkkk");
          setCustomDate({
            startTimestamp: startTimestamp.startOf("day").unix(),
            endTimestamp: endTimestamp.endOf("day").unix(),
          });
          // updateDateRange(startTimestamp, endTimestamp);
          // setOpenMenuId(false);
        }}
      /> */}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <EInvAuth
        open={cancelEOpen}
        checkbox={'eway'}
        listEway={true}
        setOpen={setCancelEOpen}
        action={async (mess, name, pass) => {
          const payload = {
            // credentials: {
            //   userName: "AL001",
            //   password: "Alankit@123",
            //   Gstin: "07AGAPA5363L002",
            //   // userName: "Matrix2050",
            //   // password: "Matrix@2050",
            //   // Gstin: "33AAHCS2907G1ZK",
            // },
            action: eWaySelect.id === 'mewb' ? 'GET_EWAY_BILL_ASSIGNED_TO_YOU_BY_DATE' : 'GET_EWAY_BILL_GENERATED_ON_YOU',
            // action: "GET_EWAY_BILL_GENERATED_ON_YOU",
            data: {
              Gen_gstin: '07AGAPA5363L002',
              date: moment(ewayDate).format('DD/MM/YYYY'),
              extraDetails: 'Y',
            },
            // credentials: prevData,
            ...(name ? { credentials: { userName: name, password: pass } } : null),
          };
          if (mess === 'success') {
            try {
              const res = await axiosInstanceForLambda.post(`${API_ENDPOINTS.REACT_APP_EWAYBILL_URL}`, payload);

              localStorage.setItem('ewayListData', JSON.stringify(res.data.data));
              if (res.data.status === 'success' && eWaySelect.id === 'mewb') {
                setList(res.data.data);
              } else {
                setOtherList(res.data.data);
              }
            } catch (err) {
              const message = err?.response?.data?.details[0]?.errorDesc;
              if (message) {
                showWarningSnackbar(message);
              } else {
                showWarningSnackbar('Something went wrong');
              }
              console.log(err, 'lololoooooo');
            }
          }
          // if (action === 'geneway') {
          //   ewayNav(actionData);
          // } else if (connectCheckbox.includes('eway')) {
          //   setCancelEInv(true);
          // }
        }}
        // // setCancelEInv={setCancelEInv}
        // authOk={async () => {

        // }}
      />
    </Box>
  );
};

export default ListEwayBill;
